import { render, staticRenderFns } from "./TravelCategory.vue?vue&type=template&id=071830c9&scoped=true"
import script from "./TravelCategory.vue?vue&type=script&lang=js"
export * from "./TravelCategory.vue?vue&type=script&lang=js"
import style0 from "./TravelCategory.vue?vue&type=style&index=0&id=071830c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071830c9",
  null
  
)

export default component.exports